import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=c2469124&scoped=true&"
import script from "./how-it-works.vue?vue&type=script&lang=js&"
export * from "./how-it-works.vue?vue&type=script&lang=js&"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=c2469124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2469124",
  null
  
)

export default component.exports